import type { LightingAnswers } from '~/types/lightingAdvisor';

/** True when at least one LA answer is set (enough to request recommendations). */
export function hasAnyLightingAnswer(answers: LightingAnswers): boolean {
  return Object.values(answers).some(
    (value) => value != null && String(value).trim() !== ''
  );
}
